import { Account } from '../Modules/Account/Model/Account';
import { calcRemaining } from '../Modules/Slot/Domain/UseCase/Utils/DateUtil';
import { CreateSlotDTO, SimpleAccount, Slot } from '../Modules/Slot/Model/Slot';
import { User } from '../Modules/User/Model/User';

let tempIdCounter = -1;

export function createTempSlotId(): number {
  tempIdCounter -= 1;
  return tempIdCounter;
}

function toSimpleAccount(account: Account | undefined): SimpleAccount {
  if (!account) {
    return { id: 0, username: '-', grade: 'SELLER', name: '-' };
  }
  return {
    id: account.id,
    username: account.username,
    grade: account.grade,
    name: account.name,
  };
}

export function buildOptimisticSlot(
  dto: CreateSlotDTO,
  me: User,
  accounts: Account[],
  tempId: number,
  slotNumber?: string,
): Slot {
  const seller = accounts.find((a) => a.id === dto.sellerId);
  const sellerParent = seller?.parent
    ? accounts.find((a) => a.id === seller.parent)
    : undefined;

  return {
    slotId: tempId,
    sellerId: dto.sellerId,
    creator: me.id,
    creator_username: me.username,
    manager: dto.manager ?? null,
    user: dto.sellerId,
    user_username: seller?.username ?? null,
    parent: toSimpleAccount(sellerParent),
    user_parent: toSimpleAccount(sellerParent),
    slot_number: slotNumber ?? dto.slot_number,
    main_keyword: dto.main_keyword,
    word_keyword: dto.word_keyword ?? '-',
    mid_single: dto.mid_single,
    mid_compare: dto.mid_compare ?? '',
    product_url: dto.product_url,
    compare_url: dto.compare_url ?? '',
    memo: dto.memo,
    start_date: dto.start_date,
    end_date: dto.end_date,
    remaining_days: calcRemaining(dto.end_date),
    status: dto.status ?? '정상',
    today_rank: null,
    yesterday_rank: null,
    rank_check_status: 'pending',
    _rankPending: true,
    _optimistic: true,
  };
}

export function buildOptimisticSlotsFromRequest(
  request: { count: number; slots: CreateSlotDTO[] },
  me: User,
  accounts: Account[],
  baseIndex = 0,
): { tempIds: number[]; slots: Slot[] } {
  const tempIds: number[] = [];
  const slots: Slot[] = [];

  if (request.slots.length === 1) {
    const baseDto = request.slots[0];
    for (let i = 0; i < request.count; i++) {
      const tempId = createTempSlotId();
      tempIds.push(tempId);
      slots.push(
        buildOptimisticSlot(
          baseDto,
          me,
          accounts,
          tempId,
          baseDto.slot_number || `pending-${baseIndex + i + 1}`,
        ),
      );
    }
    return { tempIds, slots };
  }

  request.slots.forEach((dto) => {
    const tempId = createTempSlotId();
    tempIds.push(tempId);
    slots.push(buildOptimisticSlot(dto, me, accounts, tempId));
  });

  return { tempIds, slots };
}
